import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, User, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) {
      navigate('/admin', { replace: true });
    }
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Welcome back!');
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: 'linear-gradient(135deg, #fdf2f5 0%, #fbe6ee 50%, #f7d9e5 100%)' }}
    >
      <div
        className="w-full max-w-md bg-white rounded-2xl p-8 md:p-10"
        style={{ boxShadow: '0 1px 3px rgba(196,71,122,.06), 0 16px 48px -16px rgba(196,71,122,.25)' }}
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#fdf2f5] flex items-center justify-center">
            <Lock className="w-7 h-7 text-[#c4477a]" strokeWidth={1.5} />
          </div>
          <h1 className="font-display text-2xl text-[#5a1d3b] mb-1" style={{ fontWeight: 500 }}>
            Admin Login
          </h1>
          <p className="text-sm text-gray-500">Dalaa Beauty Center &amp; Academy</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <Label className="mb-2 block text-sm text-[#5a1d3b]">Username</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                required
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="h-11 pl-9"
                placeholder="admin"
              />
            </div>
          </div>
          <div>
            <Label className="mb-2 block text-sm text-[#5a1d3b]">Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <Input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11 pl-9"
                placeholder="••••••••"
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#c4477a] hover:bg-[#a83668] text-white rounded-full h-12 font-medium"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Login'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
